import classNames from 'classnames';
import React from 'react';
import * as IconFile from '../../assets/images';
import './icon.scss';

export const iconNames = [
  'AddCellBelow',
  'AddCell',
  'Alarm',
  'Archive',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'Bookmark',
  'Cricle1',
  'Cricle2',
  'Clock',
  'Close',
  'Cloud',
  'Copy',
  'Coupon',
  'Cut',
  'Dashboard',
  'Docs',
  'Dot',
  'Download',
  'Edit',
  'Editor',
  'Erase',
  'Filter',
  'Graph',
  'Home',
  'Idea',
  'Level',
  'Lock',
  'More',
  'Paste',
  'Pause',
  'PlayAll',
  'Play',
  'Project',
  'Restart',
  'Save',
  'Search',
  'Select',
  'Send',
  'Stop',
  'Switch',
  'Trash',
  'UserSecession',
  'User',
  'VisibilityOff',
  'Visibility',
] as const;
export type IconName = typeof iconNames[number];

interface IconProps {
  name: IconName;
  width?: number;
  height?: number;
  color?: string;
  tabIndex?: number;
  className?: string;
}

const Icon = ({
  name,
  width = 20,
  height = 20,
  color = undefined,
  tabIndex = 0,
  className,
}: IconProps) => {
  const IconComponent = IconFile[name];
  return (
    <i
      className={classNames({
        icon: true,
        [`${className}`]: className,
      })}
    >
      <IconComponent
        width={width}
        height={height}
        fill={color}
        tabIndex={tabIndex}
      />
    </i>
  );
};

export default Icon;
